<template>
    <main class="page-content content-wrap">
        <NavBar v-if="isLoggedIn"/>

        <SideBar v-if="isLoggedIn"/>
        <notifications group="notify"/>
        <div style="position: fixed; top:200px; left: 200px; display: block">
            {{isLoggedIn}}
        </div>
        <router-view/>
    </main>

</template>

<script>
    import NavBar from './components/Nav/NavBar';
    import SideBar from './components/Nav/SideBar';

    export default {
        name: 'App',
        data() {
            return {
                isLoggedIn: false
            };
        },
        components: {
            NavBar,
            SideBar
        },

        updated() {
            this.isLoggedIn = this.$storage.get('access_token');
            if (this.$route.path !== '/login' && !this.isLoggedIn) {
                this.$router.push('/login');
            }
        },
        created() {
            this.$storage.set('token_expired',false);

            this.isLoggedIn = this.$storage.get('access_token');
            if (this.$route.path !== '/login' && !this.isLoggedIn) {
                this.$router.push('/login');
            }
        },
        watch: {
            isLoggedIn: function(){}
        }
    }
</script>

<style>
    @import 'https://use.fontawesome.com/releases/v5.5.0/css/all.css';

    .navbar .logo-box, .page-content, .page-inner, .topmenu-outer {
        background-color: #f3f6fb !important;
    }

    .sidebar, .menu {
        background-color: #194b6f !important;
    }

    .menu.accordion-menu > li > a:hover {
        background-color: #008fcc !important;
    }

    .navbar .logo-box .logo-text {
        padding: 0;
        line-height: unset;
    }

    .navbar .logo-box .helper {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

    .logo-box img {
        width: 100%;
    }

    .btn-logout {
        background: transparent none repeat scroll 0 0;
        outline: 0 none;
        border: medium none;
        vertical-align: middle;
        display: block;
        padding: 20px 18px;
        color: #5F5F5F;
        position: relative;
        line-height: 20px;
    }

    .top-avatar {
        outline: 0 none;
        border: medium none;
        vertical-align: middle;
        display: block;
        color: #5F5F5F;
        position: relative;
        line-height: 20px;
        background: transparent none repeat scroll 0 0;
        font-weight: 600;
    }

    .flash__wrapper {
        position: absolute;
        right: 10px;
        top: 70px;
    }

    .v-collapse-content {
        max-height: 0;
        transition: max-height 0.3s ease-out;
        overflow: hidden;
        padding: 0;
    }
    .v-collapse-content-end {
        transition: max-height 0.3s ease-in;
        max-height: 500px;
    }

    span.username {
        display: block;
        padding: 20px 18px;
        color: #5f5f5f;
        border: none;
        position: relative;
        line-height: 20px;
    }

    th
    {
        white-space: nowrap;
    }

    th fieldset.form-group
    {
        margin-bottom: 0px;
    }

    td.actions
    {
        white-space: nowrap;
    }

    @-moz-document url-prefix('') {

        table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::after {
            right: -0.25em;
        }
        table.b-table > thead > tr > th.sorting::before, table.b-table > tfoot > tr > th.sorting::before {
            right: 0.25em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue